import { SearchResult } from '#server/models';
import { featureConfig } from '@/env-exports';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  ResultCardContent,
  ResultCardMedia,
  Badge,
  Divider,
  HighlightedText,
} from '@/components';
import { cn, formatEventDateRange } from '@/utils';

export interface EventResultCardProps {
  result: SearchResult;
}

// Helper function to remove HTML tags

const removeHtmlTags = (str: string): string => {
  return str.replace(/<[^>]*>/g, '');
};

export const EventResultCard = ({ result }: EventResultCardProps) => {
  const eventDetails = result.eventDetails!;

  return (
    <ResultCardLink to={eventDetails.url} result={result}>
      <ResultCard className={cn((result.forYou ?? false) && 'border-highlight-border bg-highlight-bg')}>
        <div className="grow">
          <ResultCardHeader>
            <ResultCardTag>
              {(result.forYou ?? false) && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
              <Badge variant={(result.forYou ?? false) ? 'forYou' : 'secondary'}>Event</Badge>
            </ResultCardTag>
            <ResultCardTitle>{eventDetails.title}</ResultCardTitle>
            <ResultCardDescription>
              <HighlightedText text={eventDetails.description} />
            </ResultCardDescription>
          </ResultCardHeader>
          <ResultCardContent>
            <Divider className={cn((result.forYou ?? false) && 'bg-highlight-divider')} />
            <div
              className={cn(
                'mt-4 flex flex-col gap-4 rounded-lg bg-primary-website-background-colour px-5 py-3 text-sm',
                (result.forYou ?? false) && 'bg-white',
              )}
            >
              <div className="flex gap-8">
                <div className="w-10 font-semibold">Date</div>
                <div className="text-secondary-grey-01">
                  {formatEventDateRange(eventDetails.eventStartDate, eventDetails.eventEndDate)}
                </div>
              </div>
              <div className="flex gap-8">
                <div className="w-10 font-semibold">Location</div>
                <div className="text-secondary-grey-01">
                  {eventDetails.location ? removeHtmlTags(eventDetails.location) : ''}
                </div>
              </div>
            </div>
          </ResultCardContent>
        </div>
        {featureConfig.showEventsNewsPictures && eventDetails.imageUrl && (
          <ResultCardMedia src={eventDetails.imageUrl} alt="Event" />
        )}
      </ResultCard>
    </ResultCardLink>
  );
};
